import { render, staticRenderFns } from "./powerpoint_template.vue?vue&type=template&id=4c0a2650&scoped=true"
import script from "./powerpoint_template.vue?vue&type=script&lang=js"
export * from "./powerpoint_template.vue?vue&type=script&lang=js"
import style0 from "./powerpoint_template.vue?vue&type=style&index=0&id=4c0a2650&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0a2650",
  null
  
)

export default component.exports